// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oMPL6tatUOnZsKsAir_H-"};